import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { ToastProvider } from "@/context/ToastContext";
import { SiteContentProvider } from "@/context/SiteContentContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AdminAuthProvider>
        <ToastProvider>
          <SiteContentProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <AppRoutes />
            </BrowserRouter>
          </SiteContentProvider>
        </ToastProvider>
      </AdminAuthProvider>
    </I18nextProvider>
  );
}

export default App;